import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { Chart, Series, CommonSeriesSettings, Legend, ArgumentAxis, Label, Animation, Tooltip, Grid, CommonAxisSettings } from 'devextreme-react/chart';
import WidgetSettings from "../widgetSettings";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "../widgetTools";
import { ProgressBar, Row, Col } from "react-bootstrap";

function AnalysisByCriteria(props) {

    const { t } = useTranslation();
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [channel, setChannel] = useState(localStorage.getItem(`AnalysisByCriteria_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`AnalysisByCriteria_channelName_${props.identifier}_user${props.id}`) || "");
    const [criteria, setCriteria] = useState([]);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/analysisbycriteria", {}, JSON.stringify({
                    token: props.token,
                }));
                MonitorWSService.stompClient.unsubscribe("analysisbycriteria");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`AnalysisByCriteria_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`AnalysisByCriteria_channel_${props.identifier}_user${props.id}`) || "";
            setSelectedGroups(selectedGroups);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysisbycriteria/`, function (callsbygroup) {
                if (localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    setCriteria(data);
                }
            }, { id: "analysisbycriteria" });

            MonitorWSService.stompClient.send("/app/subscribe/analysisbycriteria", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`AnalysisByCriteria_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`AnalysisByCriteria_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`AnalysisByCriteria_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/analysisbycriteria", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };

    const customizeTooltip = (arg) => {
        return {
            text: `${arg.seriesName}: ${arg.valueText}`,
        };
    }

    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("magnifying-glass-chart")} /> {t("analysisbycriteria")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "80%", overflow: "auto" }}>
                {
                    criteria.map((c, i) => {
                        return <Row key={`cat_${i}`}>
                            <Col lg={5} >
                                <span style={{ lineHeight: "45px" }} className="fs-3 text-gray-800 fw-semibold mb-7">{t(c.concept)}</span>
                            </Col>
                            <Col lg={6}>
                                <ProgressBar style={{ marginTop: "15px" }}>
                                    {
                                        c.percent >= 70 &&
                                        <ProgressBar variant="success" now={c.percent} key={1} />
                                    }
                                    {
                                        c.percent > 30 && c.percent < 70 &&
                                        <ProgressBar variant="gray-800" now={c.percent} key={1} />
                                    }
                                    {
                                        c.percent <= 30 &&
                                        <ProgressBar variant="danger" now={c.percent} key={1} />
                                    }

                                    <ProgressBar style={{ backgroundColor: 'hsla(233, 6%, 72%, 0.37)' }} now={c.rest} key={2} />
                                </ProgressBar>
                            </Col>
                            <Col lg={1}>
                                <span style={{ lineHeight: "45px" }} className="card-label fw-bold text-gray-800">
                                    {
                                        c.percent >= 70 &&
                                        <span className="text-success" ><FontAwesomeIcon icon={duotone("face-smile")} /> {Math.round(c.percent)}%</span>
                                    }
                                    {
                                        c.percent > 30 && c.percent < 70 &&
                                        <span className="text-gray-800" ><FontAwesomeIcon icon={duotone("face-meh")} /> {Math.round(c.percent)}%</span>
                                    }
                                    {
                                        c.percent <= 30 &&
                                        <span className="text-danger" ><FontAwesomeIcon icon={duotone("face-angry")} /> {Math.round(c.percent)}%</span>
                                    }
                                </span>
                            </Col>
                        </Row>
                    })
                }
                {/* <Chart
                    id="analysisbycriteria"
                    dataSource={criteria}
                    height={"345px"}
                    rtlEnabled={props.rtl}

                >
                    <CommonAxisSettings>
                        <Grid visible={false} />
                    </CommonAxisSettings>
                    <CommonSeriesSettings argumentField="concept" type="stackedbar" barWidth={30} barPadding={0.2} />
                    <Series
                        valueField="percent"
                        name={t("attended")}
                        color={"#50cd89"}
                    />
                    <Series
                        valueField="rest"
                        name={t("missed")}
                        color={"#ccc"}

                    />

                    <ArgumentAxis>
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        />
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                        itemTextPosition="top"
                    />
                    <Animation
                        enabled={false}
                    />
                    <Tooltip
                        enabled={true}
                        location="edge"
                        customizeTooltip={customizeTooltip}
                    />
                </Chart> */}
            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(AnalysisByCriteria);